/*
 * useScrollTop - this hook is used automatically scroll top the page for user on page change
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
    }, [pathname]);

    return children;
}

export default ScrollToTop;